var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8395 5.71653L7.46452 10.0915C7.40355 10.1527 7.3311 10.2013 7.25134 10.2344C7.17157 10.2675 7.08605 10.2845 6.99967 10.2845C6.9133 10.2845 6.82778 10.2675 6.74801 10.2344C6.66824 10.2013 6.5958 10.1527 6.53483 10.0915L2.15983 5.71653C2.03655 5.59324 1.96729 5.42604 1.96729 5.25169C1.96729 5.07733 2.03655 4.91013 2.15983 4.78684C2.28311 4.66356 2.45032 4.5943 2.62467 4.5943C2.79902 4.5943 2.96623 4.66356 3.08952 4.78684L7.00022 8.69754L10.9109 4.78629C11.0342 4.66301 11.2014 4.59375 11.3758 4.59375C11.5501 4.59375 11.7173 4.66301 11.8406 4.78629C11.9639 4.90958 12.0332 5.07679 12.0332 5.25114C12.0332 5.42549 11.9639 5.5927 11.8406 5.71598L11.8395 5.71653Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.80efa8fa325f495d61c995917a0caf5d.svg";
export { ForwardRef as ReactComponent };